import { Box, Typography } from "@mui/material";
import useColors from "../../../api/hooks/useColors";
import SvgToIcon from "../../../icons/SvgToIcon";
import { icons } from "../../stack/environment/icons/iconExport";

const TrendIndicator = ({ data, showPercent }) => {
  const colors = useColors();
  if (!data || data.diff === 0 || data.percentChange === 0) return null;

  const isPositive = data.isPositive;
  const icon = isPositive ? icons.ArrowUpIcon : icons.ArrowDownIcon;
  const color = isPositive ? colors.success_400 : colors.error_400;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      <SvgToIcon
        IconLogo={icon}
        style={{
          width: "16px",
          height: "16px",
          color: color,
        }}
      />
      <Typography
        variant="caption"
        sx={{
          color: color,
        }}
      >
        {isPositive ? "+" : ""}
        {showPercent ? data.percentChange + "%" : data.diff}
      </Typography>
    </Box>
  );
};

export default TrendIndicator;
